import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div>
    {' '}
        Böyle bir sayfa yok.
    <Link to="/">
            Ana Sayfa
    </Link>
  </div>
);


export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/not-found/index.js